import { render, staticRenderFns } from "./FilterMenu.vue?vue&type=template&id=4f06a5d1&scoped=true"
import script from "./FilterMenu.vue?vue&type=script&lang=js"
export * from "./FilterMenu.vue?vue&type=script&lang=js"
import style0 from "./FilterMenu.vue?vue&type=style&index=0&id=4f06a5d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f06a5d1",
  null
  
)

export default component.exports